import {
  Box,
  Button,
  Input,
  Stack,
  chakra,
  useColorModeValue as mode,
  useToast,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { asyncPost } from '@lib/fetch';

const SubscribeForm = ({ slug, name }: { slug: string; name: string }) => {
  const { t } = useTranslation(['common']);
  const { register, handleSubmit } = useForm();
  const toast = useToast();

  const [subscribed, setSubscribed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (subscribed) {
    return (
      <Box w="full" py={4}>
        <chakra.h6>
          {t(
            'common:Thanks for the subscription, you will get the notification for the new events'
          )}
        </chakra.h6>
      </Box>
    );
  }

  return (
    <form
      onSubmit={handleSubmit(async ({ email }) => {
        setIsSubmitting(true);

        try {
          await asyncPost({
            url: '/api/mutation/subscribeToBrand',
            body: {
              slug,
              email,
            },
          });
          toast({
            title: t(`common:Subscribed to {{name}}`, { name }),
            status: 'success',
          });
          setSubscribed(true);
        } catch (err) {
          toast({ title: err, status: 'error' });
        } finally {
          setIsSubmitting(false);
        }
      })}
    >
      <Stack w="full" spacing="4" direction={{ base: 'column', sm: 'row' }}>
        <Input
          type="email"
          placeholder={t('common:Enter your Email')}
          w="full"
          isRequired
          {...register('email')}
        />
        <Button
          colorScheme="blue"
          px="10"
          type="submit"
          isDisabled={isSubmitting}
          isLoading={isSubmitting}
        >
          {t('common:Subscribe')}
        </Button>
      </Stack>
    </form>
  );
};

function EmailSubscribe({ name, slug }: { name: string; slug: string }) {
  const { t } = useTranslation(['common']);
  return (
    <Box w="full" p={8}>
      <chakra.h4 mb={4}>
        {t(
          "common:Subscribe to {{name}}'s live sessions, get notice for the latest event at the first time",
          {
            name,
          }
        )}
      </chakra.h4>
      <SubscribeForm slug={slug} name={name} />
    </Box>
  );
}

export default EmailSubscribe;
